export const variants: Array<'outlined' | 'filled' | 'standard'> = ['outlined', 'filled', 'standard'];

export const defaultValue = 'Hello, @[Kaladin Stormblessed](kaladin)!';

export const stormlight = [
    {
        id: 'kaladin',
        display: 'Kaladin Stormblessed',
        image: 'https://uploads.coppermind.net/The_Next_Ideal.png',
    },
    { id: 'adolin', display: 'Adolin Kholin', image: 'https://uploads.coppermind.net/Adolin.jpg' },
    {
        id: 'shallan',
        display: 'Shallan Davar',
        image: 'https://uploads.coppermind.net/thumb/Whelan_Stormlight_Shallan.jpg/1200px-Whelan_Stormlight_Shallan.jpg',
    },
    {
        id: 'dalinar',
        display: 'Dalinar Kholin',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMwR_sTrfoxCo8a8bYFl-HZTRR7mnLURNnR0vRiiOHZQ&s=10',
    },
    { id: 'renarin', display: 'Renarin Kholin' },
    { id: 'syl', display: 'Syl' },
    { id: 'teft', display: 'Teft' },
    { id: 'hoid', display: 'Hoid' },
    { id: 'moash', display: 'Moash' },
    { id: 'sadeas', display: 'Torol Sadeas' },
    { id: 'amaram', display: 'Amaram' },
    { id: 'nohadon', display: 'Nohadon' },
];

export const mistborn = [
    { id: 'kelsier', display: 'Kelsier' },
    { id: 'vin', display: 'Vin' },
    { id: 'elend', display: 'Elend' },
    { id: 'sazed', display: 'Sazed' },
    { id: 'ham', display: 'Ham' },
    { id: 'breeze', display: 'Breeze' },
    { id: 'clubs', display: 'Clubs' },
    { id: 'spook', display: 'Spook' },
    { id: 'tensoon', display: 'TenSoon' },
    { id: 'wax', display: 'Waxillium Ladrian' },
    { id: 'marasi', display: 'Marasi Colms' },
    { id: 'wayne', display: 'Wayne' },
    { id: 'steris', display: 'Steris Colms' },
];
